import { WORK_ORDERS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/work_orders_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { REFRIGERANT_EVENT_WORK_ORDER_PICKER } from '../utils/RefrigerantUtils';

const initialState: any = standardInitialStateGenerator([
	'workOrdersIndex',
	'workOrdersTable',
	'archivedWorkOrdersIndex',
	'allWorkOrdersIndex',
	'FETCH_DATA_FROM_SERVER_locationAssociatedActiveWorkOrders',
	'FETCH_DATA_FROM_SERVER_locationAssociatedActiveSupplierWorkOrders',
	'FETCH_DATA_FROM_SERVER_locationAssociatedInActiveWorkOrders',
	'FETCH_DATA_FROM_SERVER_locationAssociatedInActiveSupplierWorkOrders',
	'FETCH_DATA_FROM_SERVER_assetAssociatedActiveWorkOrders',
	'FETCH_DATA_FROM_SERVER_assetAssociatedInActiveWorkOrders',
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedOpenWorkOrders',
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedWorkHistory',
	'ATTENTION_DASHBOARD_STALE_WORK_ORDERS',
	'ATTENTION_DASHBOARD_EMERGENCY_WORK_ORDERS',
	'ATTENTION_DASHBOARD_PENDING_QUOTE_WORK_ORDERS',
	'ATTENTION_DASHBOARD_PENDING_APPROVAL_WORK_ORDERS',
	'ATTENTION_DASHBOARD_COMPLETED_NOT_INVOICED',
	'asset_downtime_work_orders',
	'asset_search_work_orders',
	'linkedWorkOrders',
	'linkedWorkOrdersModal',
	'workOrdersCalendarIndex',
	'workOrdersScheduleIndex',
	'projectWorkOrders',
	'DELIVERABLE_LINKED_WORK_ORDERS',
	'deliverableLinkWorkOrdersModal',
	// Picker in the "Link Work Order" modal on a walkthrough task.
	'walkthroughTaskLinkWorkOrdersModal',
	// The optional work-order link in the refrigerant log-event drawer.
	REFRIGERANT_EVENT_WORK_ORDER_PICKER,
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
